import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Dingley – South Connection Network</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        The South Connection Network of the Dingley Recycled Water Scheme is around 3.4 km of the total 42km scheme. One pipeline extends east along Lower Dandenong Road and Springvale Road. The second pipeline extends from Braeside Park under the Mordialloc Freeway. 
        </p>
        <p>
        We’re still tendering the South Connection Network with our industry partners. We’ll update our website when we’ve awarded this section. 
        </p>
             <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/residential/upgrades-and-projects/projects/dingley-recycled-water-scheme/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Dingley - Recycled Water Scheme Reticulation Networks (Stage 2)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800330129">1800 330 129</a> |{' '}
          <a
            href="mailto:dingley@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map - Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: DINGLEY@SEW.COM.AU - Dingley - Recycled Water Scheme Reticulation Networks (Stage 2)',
              });
            }}
          >
            dingley@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
